<script>
  import gql from "graphql-tag";
  import { _ as t, locale } from "svelte-i18n";
  import { languageInit } from "i18n/language.js";

  import Button from "components/Button.svelte";
  import Input from "components/Input.svelte";
  import Errors from "components/GraphQLErrors.svelte";
  import { client } from "apollo.js";
  import { currentLang } from "./stores.js";
  import LangSwitch from "components/LangSwitch.svelte";

  import {
    checkValidPassword,
    checkSamePassword,
    checkMinimumLength,
  } from "../passwordUtils.js";

  languageInit(window.location.hostname);
  let lang = $locale;
  currentLang.set(lang);

  const token = window.token;

  let password;
  let passwordConfirm;

  let errorMessages = [];

  const resetErrors = () => {
    errorMessages = [];
  };

  const RESET_PASSWORD_MUTATION = gql`
    mutation ($token: String!, $password: String!) {
      resetPasswordUser(token: $token, password: $password) {
        email
      }
    }
  `;

  const resetPassword = async (token, password) => {
    const result = await client.mutate({
      mutation: RESET_PASSWORD_MUTATION,
      variables: { token, password },
    });
    return result;
  };

  const handleReset = (password) => {
    resetPassword(token, password)
      .then((r) => {
        // Redirect to main site
        window.location.href = "/";
      })
      .catch((error) => {
        errorMessages = error.graphQLErrors;
        console.log(errorMessages);
      });
  };

  $: isValidForm = checkValidPassword(password, passwordConfirm);
  $: samePassword = checkSamePassword(password, passwordConfirm);
  $: minLength = checkMinimumLength(password);
</script>

<div class="bg">
  <div class="main">
    <div class="header">
      <h1>{$t("resetPassword")}</h1>
      <LangSwitch />
    </div>

    {#if !minLength}
      <p class="hint">{$t("minLengthPassword")}</p>
    {:else}
      <p class="hint">&#8203;</p>
    {/if}

    <Input
      on:change={resetErrors}
      bind:value={password}
      type="password"
      key="password"
      label={$t("password")}
    />
    <Input
      bind:value={passwordConfirm}
      type="password"
      key="passwordConfirm"
      label={$t("passwordConfirmation")}
    />

    <Errors {errorMessages} />

    {#if !samePassword}
      <p class="hint">{$t("confirmationNotMatch")}</p>
    {:else}
      <p class="hint">&#8203;</p>
    {/if}

    <Button active={isValidForm} on:click={() => handleReset(password)}>
      {$t("setPassword")}
    </Button>
  </div>
</div>

<style>
  .bg {
    position: fixed;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.66);
  }

  .main {
    position: relative;
    width: 40rem;
    max-width: 100%;
    max-height: 100%;
    margin: 2rem auto;
    color: black;
    background: white;
    padding: 4rem;
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  h1 {
    font-weight: 300;
    font-size: 32px;
    margin: 0;
  }

  .hint {
    font-size: 12px;
  }
</style>
